import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import './SiteNavbar.css';

const SiteNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 40) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const whatsappMessage = encodeURIComponent("السلام عليكم، أود الاستفسار عن خدمات أعمال المسبح.");

  return (
    <Navbar
      expand="lg"
      className={`site-navbar ${isScrolled ? 'scrolled' : ''}`}
      fixed="top"
    >
      <Container>
        <Navbar.Brand onClick={() => scrollTo('hero')} className="brand clickable">
          <img
            src="/images/logo.webp"
            alt="Aamal"
            className="brand-logo"
            loading="lazy"
          />
          <span className="brand-text">أعمال المسبح التجارية</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="main-nav" />
        
       <Navbar.Collapse id="main-nav">
  <Nav className="ms-auto align-items-center gap-2">
    <Nav.Link onClick={() => scrollTo('hero')}>الرئيسية</Nav.Link>
    <Nav.Link onClick={() => scrollTo('about')}>من نحن</Nav.Link>
    <Nav.Link onClick={() => scrollTo('projects')}>أعمالنا</Nav.Link>
    <Nav.Link onClick={() => scrollTo('products')}>منتجاتنا</Nav.Link>
    <Nav.Link onClick={() => scrollTo('services')}>خدماتنا</Nav.Link>
    <Nav.Link onClick={() => scrollTo('why-us')}>لماذا تختارنا؟</Nav.Link>
    <Nav.Link onClick={() => scrollTo('contact')}>تواصل معنا</Nav.Link>
  </Nav>
</Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default SiteNavbar;